import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {SystemPropsConfigs} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/property/SystemPropsConfigs';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';

const MIGRATED_VERSION:DesignerVersion = 35;

export const migration_34_35:IMigration = {
    from: MIGRATED_VERSION - 1,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === MIGRATED_VERSION - 1);

        console.log(`migration ${MIGRATED_VERSION - 1}->${MIGRATED_VERSION} designState`, designState);

        if( designState.surface && designState.surface.pages )
        {
            Object.values(designState.surface.pages).forEach((page:any) =>
            {
                if( page.artboard && page.artboard.allBoxes )
                {
                    Object.values(page.artboard.allBoxes).forEach((boxSnapshot:any) =>
                    {
                        const {componentDesc} = boxSnapshot;

                        const dndPropSnapshot:any = Object.values(componentDesc._baseProperties)
                            .find((propSnapshot:any) => propSnapshot.name === SystemPropsConfigs.DND_PROP_NAME);

                        if( dndPropSnapshot )
                        {
                            setDnDValue(dndPropSnapshot._value);
                        }
                    });
                }
            });
        }

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};

function setDnDValue(value:any)
{
    const stylesValue = {
        'isCustomPreviewStyle': {
            '__type': 'BOOLEAN',
            'value': false
        },
        'dropTargetHighlightType': {
            '__type': 'STRINGENUM',
            'selectedValue': 'None',
            'values': [
                'Self',
                'None'
            ]
        },
        'hoveredDropTargetHighlightType': {
            '__type': 'STRINGENUM',
            'selectedValue': 'None',
            'values': [
                'Self',
                'Divider',
                'None'
            ]
        },
        'dividerPlacementType': {
            '__type': 'STRINGENUM',
            'selectedValue': 'Top / Bottom edge',
            'values': [
                'Top / Bottom edge',
                'Left / Right edge',
                'Closest edge'
            ]
        },
        'previewBackground': {
            'type': {
                '__type': 'STRINGENUM',
                'selectedValue': 'Solid Color',
                'values': [
                    'Solid Color',
                    'Linear Gradient'
                ]
            },
            'solidColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#ffffff'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 1
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': true
                }
            },
            'gradientFromColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#ffffff'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 1
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': true
                }
            },
            'gradientToColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#000000'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 1
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': true
                }
            },
            'gradientAngle': {
                '__type': 'NUMBER',
                'value': 0
            }
        },
        'previewBorder': {
            'borderColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#000000'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 1
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': false
                }
            },
            'borderThickness': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 1
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'borderStyle': {
                '__type': 'STRINGENUM',
                'selectedValue': 'solid',
                'values': [
                    'solid',
                    'dashed',
                    'dotted'
                ]
            },
            'borderRadius': {
                'topLeft': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 0
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'topRight': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 0
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'bottomLeft': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 0
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'bottomRight': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 0
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                }
            },
            'borderFill': {
                '__type': 'STRINGENUM',
                'selectedValue': 'borderAll',
                'values': [
                    'borderLeft',
                    'borderTop',
                    'borderRight',
                    'borderBottom',
                    'borderAll'
                ]
            }
        },
        'previewBoxShadow': {
            'color': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#000000'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 0.5
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': false
                }
            },
            'deltaX': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 0
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'deltaY': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 2
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'blur': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 4
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'spread': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 0
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            }
        },
        'targetBackground': {
            'type': {
                '__type': 'STRINGENUM',
                'selectedValue': 'Solid Color',
                'values': [
                    'Solid Color',
                    'Linear Gradient'
                ]
            },
            'solidColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#ffffff'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 1
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': true
                }
            },
            'gradientFromColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#ffffff'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 1
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': true
                }
            },
            'gradientToColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#000000'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 1
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': true
                }
            },
            'gradientAngle': {
                '__type': 'NUMBER',
                'value': 0
            }
        },
        'targetBorder': {
            'borderColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#000000'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 1
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': false
                }
            },
            'borderThickness': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 1
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'borderStyle': {
                '__type': 'STRINGENUM',
                'selectedValue': 'solid',
                'values': [
                    'solid',
                    'dashed',
                    'dotted'
                ]
            },
            'borderRadius': {
                'topLeft': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 0
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'topRight': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 0
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'bottomLeft': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 0
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'bottomRight': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 0
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                }
            },
            'borderFill': {
                '__type': 'STRINGENUM',
                'selectedValue': 'borderAll',
                'values': [
                    'borderLeft',
                    'borderTop',
                    'borderRight',
                    'borderBottom',
                    'borderAll'
                ]
            }
        },
        'hoveredTargetBackground': {
            'type': {
                '__type': 'STRINGENUM',
                'selectedValue': 'Solid Color',
                'values': [
                    'Solid Color',
                    'Linear Gradient'
                ]
            },
            'solidColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#ffffff'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 1
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': true
                }
            },
            'gradientFromColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#ffffff'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 1
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': true
                }
            },
            'gradientToColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#000000'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 1
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': true
                }
            },
            'gradientAngle': {
                '__type': 'NUMBER',
                'value': 0
            }
        },
        'hoveredTargetBorder': {
            'borderColor': {
                'color': {
                    'hex': {
                        '__type': 'STRING',
                        'value': '#000000'
                    },
                    'alpha': {
                        '__type': 'NUMBER',
                        'value': 1
                    }
                },
                'visibility': {
                    '__type': 'BOOLEAN',
                    'value': false
                }
            },
            'borderThickness': {
                'value': {
                    '__type': 'NUMBER',
                    'value': 1
                },
                'unitsType': {
                    '__type': 'STRINGENUM',
                    'selectedValue': 'px',
                    'values': [
                        'px',
                        '%',
                        'auto'
                    ]
                }
            },
            'borderStyle': {
                '__type': 'STRINGENUM',
                'selectedValue': 'solid',
                'values': [
                    'solid',
                    'dashed',
                    'dotted'
                ]
            },
            'borderRadius': {
                'topLeft': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 0
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'topRight': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 0
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'bottomLeft': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 0
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                },
                'bottomRight': {
                    'value': {
                        '__type': 'NUMBER',
                        'value': 0
                    },
                    'unitsType': {
                        '__type': 'STRINGENUM',
                        'selectedValue': 'px',
                        'values': [
                            'px',
                            '%',
                            'auto'
                        ]
                    }
                }
            },
            'borderFill': {
                '__type': 'STRINGENUM',
                'selectedValue': 'borderAll',
                'values': [
                    'borderLeft',
                    'borderTop',
                    'borderRight',
                    'borderBottom',
                    'borderAll'
                ]
            }
        }
    };

    Object.assign(value, stylesValue);
}
